const styles = {
  contentController: {
    width: '100%',
    mt: 1,
    mb: 1,
    display: 'flex',
    alignItems: 'center',
    ' :first-of-type': {
      mt: 2,
    },
    '& .MuiFormControl-root ': {
      width: '100%',
    },
  },
  containerFields: {
    backgroundColor: 'background.white',
    p: 2,
    borderRadius: 2,
    border: '1px solid #E9E9E9',
  },
  field: {
    marginBottom: 2,
    'input:-internal-autofill-selected': {
      WebkitBoxShadow: '0 0 0 1000px white inset',
    },
    '& .MuiAutocomplete-inputRoot': {
      paddingY: '0px!important',
    },
    '& .MuiOutlinedInput-input': {
      paddingY: '12px!important',
    },
    '& ::-webkit-outer-spin-button': {
      display: 'none',
    },
    '& ::-webkit-inner-spin-button': {
      display: 'none',
    },
  },
  secondaryButtom: {
    mt: 2,
    width: '100%',
    ':hover': {
      transform: 'scale(1.02)',
    },
  },
  twoField: {
    display: 'flex',
    gap: 1,
  },
  address: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  seeOnMap: {
    marginBottom: 2,
    textAlign: 'left',
  },

  modalContainer: {

    '&.MuiDialogContent-root': {
      paddingY: 2,

    },
    '& .MuiPaper-root': {
      width: { lg: 600 },
      top: { sm: 200 },
      display: { sm: 'block' },
      margin: { sm: '0 auto!important' },
    },
  },

}

export default styles
